import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { EmailLahetysStatus } from '@lemon/core-firebase/model/lasku'

@Component({
  templateUrl: './lasku.koko-virhe.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LaskuKokoVirheDialog implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EmailLahetysStatus,
    private dialogRef: MatDialogRef<LaskuKokoVirheDialog>,
  ) {}

  ngOnInit() {}
}
